module.exports = __webpack_public_path__ + "static/img/QLD-1.db2976f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QLD-1.jpg
// module id = tapx
// module chunks = 0